import React from 'react';
import { WP_DirUser, WP_UserNetwork } from '../../model/models';
import {
  CreateUserNetworkFunc,
  DeleteUserNetworkFunc,
  UpdateUserNetworkFunc,
} from '../../hooks/WPHooks';
import { RefreshDirUserFunc } from '../../hooks/DirectoryHooks';
import { DirectoryItem } from './DirectoryItem';
import { ModelsService } from '../../services/ModelsService';

export interface DirectoryItemIdProps {
  user: WP_DirUser | null;
  network: WP_UserNetwork | undefined;
  backUrl?: string;
  create: CreateUserNetworkFunc;
  update: UpdateUserNetworkFunc;
  remove: DeleteUserNetworkFunc;
  refreshUser: RefreshDirUserFunc;
}

export const DirectoryItemId: React.FC<DirectoryItemIdProps> = ({
  user,
  backUrl,
  network,
  create,
  update,
  remove,
  refreshUser,
}) => {
  if (user) {
    return (
      <DirectoryItem
        friendStatus={network?.acf?.relation_status}
        userId={user.id}
        name={user?.name || ''}
        avatar={ModelsService.getUserAvatar(user)}
        email={user?.email || ''}
        phone={user?.acf.mobilephone || ''}
        house={ModelsService.getUserHouseName(user)}
        network={network}
        remove={remove}
        update={update}
        refreshUser={refreshUser}
        create={create}
        backUrl={backUrl}
      />
    );
  } else {
    return <></>;
  }
};
